var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.startTraining}},[_vm._v("Start Training")]),_c('b-button',{attrs:{"variant":"danger"},on:{"click":_vm.stopTraining}},[_vm._v("Stop Training")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.logs)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }